module.exports = __webpack_public_path__ + "img/icon-download.6170c139.png";